import DocumentTemplate from "@/types/documents/documentTemplate/DocumentTemplate";
import Nomenclature from "@/types/documents/nomenclature/Nomenclature";

type NomenclatureTemplateRule = {
  matches: (normalizedName: string) => boolean;
  templateNames: readonly string[];
};

const normalizeName = (value: string) =>
  value
    .trim()
    .toLocaleLowerCase("ru-RU")
    .replace(/ё/g, "е")
    .replace(/\s*\+\s*/g, "+")
    .replace(/\s+/g, " ");

const containsToken = (normalizedName: string, token: string) =>
  normalizedName.split(/[^0-9a-zа-я]+/iu).includes(token);

const NOMENCLATURE_TEMPLATE_RULES: readonly NomenclatureTemplateRule[] = [
  {
    matches: (name) => containsToken(name, "тд"),
    templateNames: [
      "ТД НКОК",
      "NDA",
      "Налоговый вычет",
      "Приказ прием",
      "Приказ увольнение",
      "Приказ БС",
      "Приказ отпуск",
      "Согласие ПД +Смарт",
    ],
  },
  {
    matches: (name) => name.includes("заявлен"),
    templateNames: [
      "Заявление на увольнение Smart Call",
      "Заявление на отпуск",
      "БС Смарт колл",
    ],
  },
  {
    matches: (name) => containsToken(name, "гпх"),
    templateNames: ["ГПХ НКОК нерезидент", "ГПХ НКОК", "NDA"],
  },
  {
    matches: (name) => containsToken(name, "ип"),
    templateNames: ["Договор ИП", "NDA"],
  },
];

export const filterDocumentTemplatesByNomenclature = (
  templates: readonly DocumentTemplate[],
  nomenclature?: Pick<Nomenclature, "name"> | null
): DocumentTemplate[] => {
  if (!nomenclature?.name) {
    return [...templates];
  }

  const normalizedNomenclatureName = normalizeName(nomenclature.name);
  const rule = NOMENCLATURE_TEMPLATE_RULES.find(({ matches }) =>
    matches(normalizedNomenclatureName)
  );

  if (!rule) {
    return [...templates];
  }

  const templatesByName = new Map<string, DocumentTemplate>();
  templates.forEach((template) => {
    const normalizedTemplateName = normalizeName(template.name);
    if (!templatesByName.has(normalizedTemplateName)) {
      templatesByName.set(normalizedTemplateName, template);
    }
  });

  const filteredTemplates = rule.templateNames
    .map((name) => templatesByName.get(normalizeName(name)))
    .filter((template): template is DocumentTemplate => template != null);

  return filteredTemplates.length > 0 ? filteredTemplates : [...templates];
};
